import * as React from 'react';
export const googlecloudSvg = React.forwardRef(function googlecloudSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm19.337 11.432.784.013 2.13-2.126.102-.901A9.54 9.54 0 0 0 15.997 6c-4.412 0-8.136 2.998-9.238 7.059.232-.162.73-.04.73-.04l4.255-.7s.22-.361.33-.34A5.31 5.31 0 0 1 16 10.248a5.322 5.322 0 0 1 3.337 1.185Z',
      fill: '#EA4335',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M25.241 13.067a9.57 9.57 0 0 0-2.888-4.65l-3.016 3.012a5.299 5.299 0 0 1 1.983 4.131v.532a2.66 2.66 0 0 1 2.66 2.655 2.66 2.66 0 0 1-2.66 2.655h-5.317l-.533.534v3.187l.533.53h5.317c3.813 0 6.915-3.099 6.915-6.906a6.91 6.91 0 0 0-2.994-5.68Z',
      fill: '#4285F4',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.68 25.655h5.315v-4.25H10.68c-.392 0-.763-.086-1.095-.238l-.767.235-2.13 2.127-.186.717a6.888 6.888 0 0 0 4.178 1.409Z',
      fill: '#34A853',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.68 11.845c-3.813 0-6.915 3.097-6.915 6.905a6.891 6.891 0 0 0 2.74 5.499l3.083-3.079a2.657 2.657 0 0 1-1.567-2.42 2.66 2.66 0 0 1 2.658-2.655c1.079 0 2.005.644 2.424 1.565l3.083-3.08a6.907 6.907 0 0 0-5.507-2.735Z',
      fill: '#FBBC05',
    }),
  );
});
googlecloudSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var googlecloud = {
  category: 'brand',
  colorable: false,
  name: 'googlecloud',
  svg: googlecloudSvg,
};
